const customfields = {
  name_en: 'English name',
  name_fr: 'French name',
};

export default customfields;
